import { render, staticRenderFns } from "./FilterDropdown.vue?vue&type=template&id=52bebad1"
import script from "./FilterDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterDropdown.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FilterDropdown.vue?vue&type=style&index=0&id=52bebad1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports